import "./StepTwo.scss";
import { ENV } from "../../../utils";
import { image } from "../../../assets";
import React, { useState } from 'react';
import { Form, Card, Image, Button } from 'semantic-ui-react';
import  { formatCurrency, dateType, maskString }  from '../../../utils/stringsAndFormats';

function StepTwo({ formData, nextStep }) {
  
  const [selectedDebtIndex, setSelectedDebtIndex] = useState(null);
  const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [rawValue, setRawValue] = useState('');
  const [inputError, setInputError] = useState(false);
  const [valueError, setValueError] = useState(null);
  const [infoMsj, setInfoMsj] = useState(null);

  const uniqueDebts = formData.debts.filter((debt, index, self) =>
    index === self.findIndex((d) => d.billNumber === debt.billNumber)
  );

  const handleSelectDebt = (index) => {
    if (selectedDebtIndex === index) {
      setSelectedDebtIndex(null);
      setOpcionSeleccionada(null); 
      setInputValue('');
    } else {
      setSelectedDebtIndex(index);
      setOpcionSeleccionada(null); 
      setInputValue('');
      if (formData.productType === '10') {
        setOpcionSeleccionada('minimo');
      }
    }
  };

  const handleSelectOpcion = (index, opcion) => {
    if (opcion === 'otro') {
      setSelectedDebtIndex(index);
      setOpcionSeleccionada('otro');
      setInfoMsj("Ingresa un valor menor al saldo total de la deuda");
    } else if (opcion === 'minimo' || opcion === 'total') {
      if (opcionSeleccionada === 'otro' && inputValue) {
        setInputValue('');
        setValueError(null);
      }
      setInfoMsj(null);
      setSelectedDebtIndex(index);
      setOpcionSeleccionada(opcion);
    } else {
      setSelectedDebtIndex(index);
    }
  };

  const handleContinue = () => {
    if (selectedDebtIndex !== null) {
      const selectedDebt = { ...formData.debts[selectedDebtIndex], opcion: opcionSeleccionada, valor: rawValue };
      nextStep({ selectedDebt });
    }
  };

  const handleInputChange = (e) => {

    let value = e.target.value;

    if (value.length > 1 && value.startsWith('0')) {
      setInputValue(value.slice(1));
      return;
    }

    value = value.replace(/\D/g, '');
    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    const selectedDebt = formData.debts[selectedDebtIndex];
    const valMax = selectedDebt.type === 'Credito' ? selectedDebt.descriptionValue1 :selectedDebt.description1;
    const numericValue = parseInt(value, 10);

    if (value === '' || numericValue <= 0 || numericValue > valMax) {

      setInputError(true);
      setInputValue(formattedValue);
      setInfoMsj(null);

      if (numericValue === 0) {
        setValueError("El valor ingresado no puede ser menor a $1 peso(s)");
      } 
      
    } else {
      setInfoMsj(null);
      setInputError(false);
      setInputValue(formattedValue);
      setValueError(null);
      if (value !== '' && opcionSeleccionada !== 'otro') {
        setOpcionSeleccionada('otro');
      }
    }
    setRawValue(value);
  };

  const handleKeyDown = (e) => {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedKeys.includes(e.key) || /^[0-9]$/.test(e.key)) {
      return; 
    }
    e.preventDefault();
  };

  return (
    <div className="steps-container">
      <div className="steps-title"><strong>Paso 2 de 4:</strong> Pagos pendientes</div>

      <p className="steps-text-big-out">Producto por pagar</p>
      <p className="steps-text-out">Selecciona el producto para el cual deseas realizar el pago</p>

      <div className="steps-card-box">
        <div className="steps-card-content">
          <div className="steps-card multi">
            <p className="steps-text-big">Producto por pagar</p>
            <p className="steps-text">Selecciona el producto para el cual deseas realizar el pago</p>

            <Card.Group id="productos_pendientes">
              {uniqueDebts.map((debt, index) => (
                <Card key={index} fluid className={selectedDebtIndex === index ? 'card-selected' : ''}>
                  <Card.Content>
                    <div className="steps-container-flex">
                      <div className="steps-container-left">
                        <div
                          id="deuda_seleccionada"
                          className={`custom-radio ${selectedDebtIndex === index ? 'checked' : 'unchecked'}`}
                          onClick={() => handleSelectDebt(index)}
                          style={{ marginRight: '10px', cursor: 'pointer' }}>
                          <div className="radio-icon" />
                        </div>
                      </div>
                      <div className="steps-container-middle"> 
                        <div className="steps-container-header">
                            {debt.descriptionValue}
                        </div>
                        <div className="steps-container-meta">
                        {debt.billNumber}
                        </div>
                      </div>
                      <div className="steps-container-right">
                        <Card.Content extra>
                        <div
                          className={selectedDebtIndex === index ? 'icon-up' : 'icon-down'}
                          onClick={() => handleSelectDebt(index)}
                          style={{ cursor: 'pointer' }}
                        />
                        </Card.Content>
                      </div>
                    </div>
                    
                    <Card.Description>
                      {selectedDebtIndex === index && formData.productType !== "10" && (
                        <div>
                           <hr className="custom-separator" />
                            <div className="steps-desc-flex">
                              <div className="steps-desc-left">Número del producto:</div>
                              <div className="steps-desc-middle"><hr className="dotted-separator"/></div>
                              <div className="steps-desc-right">{debt.billNumber}</div>
                            </div>
                            <div className="steps-desc-flex">
                              <div className="steps-desc-left">{dateType(debt.type)}</div>
                              <div className="steps-desc-middle"><hr className="dotted-separator"/></div>
                              <div className="steps-desc-right">{debt.description2}</div>
                            </div>

                            <div className="steps-values-flex" style={{ marginTop: '36px' }}>
                              <div className="steps-values-left">
                                <div className="radio-field">
                                  <div
                                    id="pago_total"
                                    className={`custom-radio-mini ${opcionSeleccionada === 'total' ? 'checked' : 'unchecked'}`}
                                    onClick={() => handleSelectOpcion(index, 'total')}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}>
                                    <div className="radio-icon" />
                                  </div>
                                  <label onClick={() => handleSelectOpcion(index, 'total')}>
                                    Pago total
                                  </label>
                                </div>
                              </div>
                              <div className="steps-values-middle"><hr className="dotted-separator"/></div>
                              <div className="steps-values-right">{debt.type === 'Credito' ? formatCurrency(debt.descriptionValue1) : formatCurrency(debt.description1)}</div>
                            </div>

                            <div className="steps-values-flex">
                              <div className="steps-values-left">
                                <div className="radio-field">
                                  <div
                                    id="pago_minimo"  
                                    className={`custom-radio-mini ${opcionSeleccionada === 'minimo' ? 'checked' : 'unchecked'}`}
                                    onClick={() => handleSelectOpcion(index, 'minimo')}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}>
                                    <div className="radio-icon" />
                                  </div>
                                  <label onClick={() => handleSelectOpcion(index, 'minimo')}>
                                    Pago mínimo
                                  </label>
                                </div>
                              </div>
                              <div className="steps-values-middle"><hr className="dotted-separator"/></div>
                              <div className="steps-values-right">{formatCurrency(debt.totalValue)}</div>
                            </div>

                            <div className="steps-values-flex">
                              <div className="steps-values-left" style={{ paddingTop: '10px' }}>
                                <div className="radio-field">
                                  <div
                                    className={`custom-radio-mini ${opcionSeleccionada === 'otro' ? 'checked' : 'unchecked'}`}
                                    onClick={() => handleSelectOpcion(index, 'otro')}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}>
                                    <div className="radio-icon" />
                                  </div>
                                  <label onClick={() => handleSelectOpcion(index, 'otro')}>
                                    Otro valor
                                  </label>
                                </div>
                              </div>
                              <div className="steps-values-middle" style={{ paddingTop: '10px' }}><hr className="dotted-separator"/></div>
                              <div className="steps-values-right total"> 
                                <Form id="producto_por_pagar">
                                  <Form.Field>
                                    <Form.Input
                                      id="valor_a_pagar"
                                      type='text'
                                      className={valueError ? 'err-input' : ''}
                                      placeholder='Ingresar valor'
                                      value={inputValue}
                                      onChange={handleInputChange}
                                      onKeyDown={handleKeyDown} 
                                      error={!!valueError}
                                    />
                                  </Form.Field>
                                </Form>
                                </div>
                            </div>
                            {valueError && <div className="error-label-right">{valueError}</div>}
                            {infoMsj && <div className="error-label-info">{infoMsj}</div>}
                         </div>
                      )}
                      {selectedDebtIndex === index && formData.productType === "10" && (
                        <div>
                          <hr className="custom-separator" />
                          <div className="steps-desc-flex">
                            <div className="steps-desc-left">Nombre del cliente</div>
                            <div className="steps-desc-middle"><hr className="dotted-separator"/></div>
                            <div className="steps-desc-right">{debt.descriptionValue1}</div>
                          </div>
                          <div className="steps-desc-flex">
                            <div className="steps-desc-left">Número de documento</div>
                            <div className="steps-desc-middle"><hr className="dotted-separator"/></div>
                            <div className="steps-desc-right">{formData.documentNumber}</div>
                          </div>
                          <div className="steps-desc-flex">
                            <div className="steps-desc-left">Número de reserva</div>
                            <div className="steps-desc-middle"><hr className="dotted-separator"/></div>
                            <div className="steps-desc-right">{debt.billNumber}</div>
                          </div>
                          <div className="steps-desc-flex">
                            <div className="steps-desc-left">Hotel</div>
                            <div className="steps-desc-middle"><hr className="dotted-separator"/></div>
                            <div className="steps-desc-right">{debt.descriptionValue2}</div>
                          </div>
                         
                          <div className="steps-values-flex" style={{ marginTop: '36px' }}>
                              <div className="steps-values-left">
                                <div className="radio-field">
                                  <div
                                    id="pago_minimo"  
                                    className={`custom-radio-mini ${opcionSeleccionada === 'minimo' ? 'checked' : 'unchecked'}`}
                                    onClick={() => handleSelectOpcion(index, 'minimo')}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}>
                                    <div className="radio-icon" />
                                  </div>
                                  <label onClick={() => handleSelectOpcion(index, 'minimo')}>
                                    Pago total
                                  </label>
                                </div>
                              </div>
                              <div className="steps-values-middle"><hr className="dotted-separator"/></div>

                              <div className="steps-values-right">{formatCurrency(debt.totalValue)}</div>
                            </div>

                            <div className="steps-values-flex">
                              <div className="steps-values-left" style={{ paddingTop: '10px' }}>
                                <div className="radio-field">
                                  <div
                                    className={`custom-radio-mini ${opcionSeleccionada === 'otro' ? 'checked' : 'unchecked'}`}
                                    onClick={() => handleSelectOpcion(index, 'otro')}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}>
                                    <div className="radio-icon" />
                                  </div>
                                  <label onClick={() => handleSelectOpcion(index, 'otro')}>
                                    Pago de saldo pendiente
                                  </label>
                                </div>
                              </div>
                              <div className="steps-values-middle" style={{ paddingTop: '10px' }}><hr className="dotted-separator"/></div>
                              <div className="steps-values-right total"> 
                                <Form id="producto_por_pagar">
                                  <Form.Field>
                                    <Form.Input
                                      id="valor_a_pagar"
                                      type='text'
                                      className={valueError ? 'err-input' : ''}
                                      placeholder='Ingresar valor'
                                      value={inputValue}
                                      maxLength={12}
                                      onChange={handleInputChange}
                                      onKeyDown={handleKeyDown} 
                                      error={!!valueError}
                                    />
                                  </Form.Field>
                                </Form>
                                </div>
                            </div>
                            <div className="error-label-right-gray">Ingresa el valor pendiente por modificación de tu reserva</div>
                        </div>
                      )}
                    </Card.Description>  
                  </Card.Content>
                </Card>
              ))}

            </Card.Group>
        
          </div>
          <div className="steps-buttons doubt">

            <div 
              className={`custom-button ${selectedDebtIndex === null ||  opcionSeleccionada === null || (opcionSeleccionada === 'otro' && (inputValue === '' || inputError)) ? 'disabled' : 'active'}`}
              onClick={() => { if (selectedDebtIndex !== null && opcionSeleccionada !== null && !inputError) { handleContinue(); } }}
              style={{ marginTop: '20px', cursor: selectedDebtIndex === null || opcionSeleccionada === null ? 'not-allowed' : 'pointer' }}>
                <span className="button-text">Continuar</span>
                <div className="button-icon" />
            </div>

         
          </div>

          <div className="steps-buttons unique">

            <Button 
              id="continuar"
              type="submit" 
              disabled={selectedDebtIndex === null ||  opcionSeleccionada === null || (opcionSeleccionada === 'otro' && (inputValue === '' || inputError)) } 
              onClick={() => { if (selectedDebtIndex !== null && opcionSeleccionada !== null && !inputError) { handleContinue(); } }}>
              Continuar
            </Button>

          </div>
        </div>

      </div>

      <div className="feet">
        <a href={ENV.BASE_BOX} className="exit_text">
          Salir
        </a>
        <a href={ENV.BASE_BOX} className="exit_icon">
          <Image src={image.logOut} />
        </a>
      </div>

    </div>
  );
} 

export default StepTwo;
